import { getPriceRangeString, getPriceString } from 'site-modules/shared/utils/price-utils';
import { getPlural } from 'client/utils/plural';
import { toSentenceCase } from 'client/utils/string-utils';

export const MSRP_LOWERCASE = 'msrp';
export const BASE_MSRP = 'baseMsrp';
export const EXPERT_RATING = 'expert_rating';
export const TOTAL_SEATING = 'total_seating';
export const RECOMMENDED_TRIM = 'recommended_trim';
export const EXTERIOR_COLORS = 'exterior_colors';
export const INTERIOR_COLORS = 'interior_colors';
export const COUNTRY_OF_FINAL_ASSEMBLY = 'Country of final assembly';

export const HIGHLIGHTS_CONFIG = [
  {
    name: BASE_MSRP,
    displayName: 'MSRP (Starting MSRP)',
    valuePath: 'trimSummary.pricing.baseMsrp',
    getFormattedValue: value => getPriceString(value),
  },
  {
    name: MSRP_LOWERCASE,
    displayName: 'MSRP',
    valuePath: 'msrpPriceRanges',
    getFormattedValue: value => {
      const minPrice = value?.min;
      const maxPrice = value?.max;

      return minPrice && maxPrice ? getPriceRangeString(minPrice, maxPrice) : '';
    },
  },
  {
    name: EXPERT_RATING,
    displayName: 'Edmunds Rating',
    valuePath: 'editorialRating',
    getFormattedValue: value =>
      (value ? `${toSentenceCase(value.rating_enum || '')} ${value.rating_number}/10` : '').trim(),
  },
  {
    name: TOTAL_SEATING,
    displayName: 'Total seating',
    valuePath: 'style.totalSeating',
    getFormattedValue: value => `${value} ${getPlural('seat', value)}`,
  },
  {
    name: RECOMMENDED_TRIM,
    displayName: 'Our recommended trim',
    valuePath: 'recommendedTrim',
  },
  {
    name: EXTERIOR_COLORS,
    displayName: 'Exterior colors',
    valuePath: 'style.color.EXTERIOR',
    getFormattedValue: value => ({
      colors: value,
      isExterior: true,
    }),
  },
  {
    name: INTERIOR_COLORS,
    displayName: 'Interior colors',
    valuePath: 'style.color.INTERIOR',
    getFormattedValue: value => ({
      colors: value,
    }),
  },
  // warranty
  {
    name: 'Basic',
    displayName: 'Basic Warranty',
  },
  {
    name: COUNTRY_OF_FINAL_ASSEMBLY,
    displayName: COUNTRY_OF_FINAL_ASSEMBLY,
  },
];
